import { z } from 'zod';
import type { SsnCountry } from '../enums.js';

/**
 * Recherche globale de l'en-tête — « Rechercher un patient, une consultation… » de la V1.
 *
 * La V1 chargeait tous les dossiers du praticien puis une requête par dossier pour ses
 * consultations, à chaque frappe, et renvoyait des lignes entières, anamnèse comprise. Ici une
 * seule requête par groupe, cloisonnée par cabinet, et des résultats réduits à ce que la liste
 * affiche : aucun texte clinique ne sort, même quand c'est lui qui a correspondu.
 */

/** En dessous de deux caractères, tout correspond : la V1 attendait aussi deux. */
export const GLOBAL_SEARCH_MIN_LENGTH = 2;
export const GLOBAL_SEARCH_MAX_LENGTH = 120;
/** Résultats par groupe, comme la V1. */
export const GLOBAL_SEARCH_GROUP_LIMIT = 5;

export const globalSearchQuerySchema = z
  .object({
    q: z.string().trim().min(GLOBAL_SEARCH_MIN_LENGTH).max(GLOBAL_SEARCH_MAX_LENGTH),
  })
  .strict();
export type GlobalSearchQuery = z.infer<typeof globalSearchQuerySchema>;

/** Un dossier trouvé : son nom, et de quoi écrire la ligne secondaire — matricule ou contact. */
export interface PatientSearchHitDto {
  id: string;
  firstName: string;
  lastName: string;
  ssn: string | null;
  ssnCountry: SsnCountry;
  email: string | null;
  phone: string | null;
}

/** Une consultation trouvée : son titre, sa date et son patient. Jamais son contenu. */
export interface ConsultationSearchHitDto {
  id: string;
  patientId: string;
  patientFirstName: string;
  patientLastName: string;
  title: string | null;
  startedAt: string;
}

export interface GlobalSearchResultDto {
  patients: PatientSearchHitDto[];
  consultations: ConsultationSearchHitDto[];
}
